import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UtilityService } from 'src/app/service/utility/utility.service';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    standalone: false
})
export class PageNotFoundComponent {

  constructor(
    private router: Router,
    private userStorage: UtilityService,
  ){}

  goToHome(){
    this.userStorage.sendToHome();
  }
}
